import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';
import * as fromConfig from './config.reducer';
import { SortableListKey } from '../../enums/sort';


export const selectConfigState = createFeatureSelector<fromConfig.State>('config');

export const selectConfigLeftPanelMode = createSelector(
  selectConfigState,
  state => state.leftPanelMode
);
export const selectConfigRightPanelMode = createSelector(
  selectConfigState,
  state => state.rightPanelMode
);
export const selectConfigDisplaySitesFilters = createSelector(
  selectConfigState,
  state => state.displaySitesFilters
);
export const selectConfigSitesFilters = createSelector(
  selectConfigState,
  state => state.sitesFilters
);
export const selectConfigColorRampPositiveColors = createSelector(
  selectConfigState,
  state => state.colorRampPositiveColors
);
export const selectConfigColorRampNegativeColors = createSelector(
  selectConfigState,
  state => state.colorRampNegativeColors
);
export const selectConfigColorRampMin = createSelector(
  selectConfigState,
  state => state.colorRampMin
);
export const selectConfigColorRampMax = createSelector(
  selectConfigState,
  state => state.colorRampMax
);
export const selectConfigSiteDetailSelectedSection = createSelector(
  selectConfigState,
  state => state.siteDetailSelectedSection
);
export const selectConfigSearchWorldText = createSelector(
  selectConfigState,
  state => state.searchWorldText
);
export const selectConfigTilesetStyleColorConditions = createSelector(
  selectConfigState,
  state => state.tilesetStyleColorConditions
);
export const selectConfigTilesetColorRampMin = createSelector(
  selectConfigState,
  state => state.tilesetColorRampMin
);
export const selectConfigTilesetColorRampMax = createSelector(
  selectConfigState,
  state => state.tilesetColorRampMax
);
export const selectConfigViewRepresentation = createSelector(
  selectConfigState,
  state => state.viewRepresentation
);
export const selectTilesetIsLoading = createSelector(
  selectConfigState,
  state => state.tilesetIsLoading
);
export const selectSplittedTilesetIsLoading = createSelector(
  selectConfigState,
  state => state.splittedTilesetIsLoading
);
export const selectConfigPointCloudPointSize = createSelector(
  selectConfigState,
  state => state.pointSize
);
export const selectConfigIsDownloadingPicture = createSelector(
  selectConfigState,
  state => state.isDownloadingPicture
);
export const selectConfigDisplayMeasures = createSelector(
  selectConfigState,
  state => state.displayMeasures
);
export const selectConfigDisplayCuts = createSelector(
  selectConfigState,
  state => state.displayCuts
);
export const selectConfigDisplayElevations = createSelector(
  selectConfigState,
  state => state.displayElevations
);
export const selectConfigDisplayMarkers = createSelector(
  selectConfigState,
  state => state.displayMarkers
);
export const selectConfigDisplayDetections = createSelector(
  selectConfigState,
  state => state.displayDetections
);
export const selectConfigDisplayVolumes = createSelector(
  selectConfigState,
  state => state.displayVolumes
);
export const selectConfigItemDetailExpanded = createSelector(
  selectConfigState,
  state => state.itemDetailExpanded
);
// export const selectConfigRightSideScreen = createSelector(
//   selectConfigState,
//   state => state.rightSideScreen
// );

export const selectSortConfig = (list: SortableListKey) =>
  createSelector(
    selectConfigState,
    (state) => state.sortConfigs[list]
  );

